import { FlagFragment } from 'src/graphql/generated/graphql'
import { useFlags } from 'src/react_query'

type Flag =
  | 'Awards Page'
  | 'New Navigation'
  | 'Usersnap'
  | 'New Dashboard'
  | 'BulkOrderFlow'
  | 'DoubleBonusDashboard'
  | 'editor_choice'
  | 'can_add_act_addon'
  | 'can_purchase_act_gift_cards'
  | 'has_gift_card_wallet'

type Flags = {
  awardPage: boolean
  newNavigation: boolean
  userSnap: boolean
  newDashboard: boolean
  bulkOrderFlow: boolean
  doubleBonusDashboard: boolean
  editorChoice: boolean
  canAddActAddon: boolean
  canPurchaseActGiftCards: boolean
  hasGiftCardWallet: boolean
}

const findFlag = (flags: string[], flag: Flag): boolean =>
  flags.find(item => item === flag) !== undefined

export const useFlag = (flags: FlagFragment[]): Flags => {
  const flagsNames: string[] = flags.map(value => value.name)
  return {
    awardPage: findFlag(flagsNames, 'Awards Page'),
    newNavigation: findFlag(flagsNames, 'New Navigation'),
    userSnap: findFlag(flagsNames, 'Usersnap'),
    newDashboard: findFlag(flagsNames, 'New Dashboard'),
    bulkOrderFlow: findFlag(flagsNames, 'BulkOrderFlow'),
    doubleBonusDashboard: findFlag(flagsNames, 'DoubleBonusDashboard'),
    editorChoice: findFlag(flagsNames, 'editor_choice'),
    canAddActAddon: findFlag(flagsNames, 'can_add_act_addon'),
    canPurchaseActGiftCards: findFlag(
      flagsNames,
      'can_purchase_act_gift_cards',
    ),
    hasGiftCardWallet: findFlag(flagsNames, 'has_gift_card_wallet'),
  }
}

// Use this when not using useQueries in the component
export const useFlagsWithUseQueries = (): Flags => {
  const { data: flags } = useFlags({ suspense: true })
  if (!flags) throw Error('Could not retrieve flags')
  return useFlag(flags)
}
